import React from 'react';
import styled from "styled-components";
import Image from "../../../components/Image";
const BreadcrumbsSeparator = () => (React.createElement(BreadcrumbsSeparatorWrapper, null,
    React.createElement(Image, { alt: 'breadcrumbs_separator', src: require('../images/breadcrumb_arrow.svg') })));
const BreadcrumbsSeparatorWrapper = styled.div `
  height: 14px;
  
  display: inline-flex;

  margin: 4px 8px;
`;
export default BreadcrumbsSeparator;
//# sourceMappingURL=BreadcrumbsSeparator.js.map